// @flow

type Page = {
  label: string,
  path: string,
};

const MANAGER_PAGES: Page[] = [
  { label: "Dashboard", path: "/dashboard" },
  { label: "Offers", path: "/offers" },
  { label: "Affiliates", path: "/affiliates" },
  { label: "Advertisers", path: "/advertisers" },
  { label: "Statistics — Reports", path: "/statistics/reports" },
  { label: "Statistics — Clicks", path: "/statistics/clicks" },
  { label: "Statistics — Conversions", path: "/statistics/conversions" },
  { label: "Control panel — Users", path: "/control-panel/users" },
  { label: "Control panel — Configuration", path: "/control-panel/configuration" },
  { label: "Control panel — Schedulers", path: "/control-panel/schedulers" },
  { label: "Billing", path: "/billing" },
];

const ADVERTISER_MANAGER_PAGES: Page[] = [
  { label: "Dashboard", path: "/dashboard" },
  { label: "Offers", path: "/offers" },
  { label: "Affiliates", path: "/affiliates" },
  { label: "Advertisers", path: "/advertisers" },
  { label: "Statistics — Reports", path: "/statistics/reports" },
  { label: "Statistics — Clicks", path: "/statistics/clicks" },
  { label: "Statistics — Conversions", path: "/statistics/conversions" },
  { label: "Control panel — Users", path: "/control-panel/users" },
  { label: "Control panel — Configuration", path: "/control-panel/configuration" },
  { label: "Control panel — Schedulers", path: "/control-panel/schedulers" },
];

export function getPagesForRole(rol: string): Page[] {
  switch (rol) {
    case "adm":
    case "ham":
    case "afm":
      return MANAGER_PAGES;
    case "him":
    case "inm":
      return ADVERTISER_MANAGER_PAGES;
    default:
      return [];
  }
}
